import { useLocation } from 'react-router-dom';

const useSplitPathname = () => {
    const location = useLocation();
    return location.pathname.split('/').filter(el => el)
}

export default useSplitPathname